import { Box, colors } from "@mui/material";

import { Droppable } from "react-beautiful-dnd";

import { FormValuesType } from "pages";

import { FieldComponent } from "./Field";

import { theme } from "constants/theme";
import { Droppables } from "constants/enum";

export const SectionItemList: React.FC<{
  fieldsList: FormValuesType[];
  sectionId: string;
  resetFormWithValues: (item: FormValuesType) => void;
  removeField: (fieldId: string, fieldIndex: number) => void;
}> = ({ fieldsList, sectionId, resetFormWithValues, removeField }) => {
  return (
    <Droppable droppableId={sectionId} type={Droppables.FIELD}>
      {(provided, snapshot) => (
        <Box
          ref={provided.innerRef}
          {...provided.droppableProps}
          sx={{
            minHeight: "100px",
            border: fieldsList.length ? theme.borderPrimary : "",
            p: 2,
            borderRadius: 1,
            display: "flex",
            flexDirection: "column",
            gap: theme.gap,
            bgcolor: snapshot.isDraggingOver ? colors.blue["50"] : "inherit",
          }}
        >
          {fieldsList.map((item, i) => (
            <FieldComponent
              index={i}
              item={item}
              key={item.id}
              resetFormWithValues={() => resetFormWithValues({ ...item })}
              deleteHandler={() => removeField(item.id, i)}
            />
          ))}

          {provided.placeholder}
        </Box>
      )}
    </Droppable>
  );
};
